/** @format */
import { ReactNode } from 'react';

import {
    PaginationItemProps,
    PaginationVariant,
} from '@toucan/client/shared/components/pagination';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum CarouselVariant {
    MINIMAL = 'minimal',
    FULL = 'full',
}

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type CarouselProps = {
    'data-testid'?: string;
    className?: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    showPagination?: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    showExpandButton?: boolean;
    initialPage?: number;
    imageAspectRatio?: string;
    maxSlideHeight?: string;
    onFocussedItemClick?: (index: number) => void;
    onActiveIndexChange?: (index: number) => void;

    /**
     * Variant of the carousel
     *
     * @default MINIMAL
     */
    variant?: CarouselVariant;

    /**
     * The items to be displayed in the carousel
     */
    items: ReactNode[];

    /**
     * The display variant of the pagination item to be displayed.
     * No pagination is displayed if this property is not passed.
     *
     * @default DOT
     */
    paginationVariant?: PaginationVariant;

    /**
     * The items to be displayed in the pagination
     */
    paginationItems?: PaginationItemProps[];
    note?: string;
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type StyledCarouselProps = CarouselProps & {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    showNextButton: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    showPrevButton: boolean;
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type CarouselModalProps = Pick<
    CarouselProps,
    | 'className'
    | 'data-testid'
    | 'initialPage'
    | 'onActiveIndexChange'
    | 'items'
    | 'paginationItems'
    | 'note'
>;
